import { Button } from "@/components/ui/button";
import { cn } from "@/utils/class-name";
import { SeriesLabel } from "./series-label";
import { UNIT_BADGE_PADDING_CLASS, UNIT_BADGE_TYPE_CLASS } from "./unit-badge-tokens";

export function PanelMetricBadge({
    unitCategory,
    deviceName,
}: {
    unitCategory: string | null;
    deviceName: string | null;
}) {
    if (!unitCategory && !deviceName) return null;

    return (
        <Button
            className={cn(
                "pointer-events-none absolute top-2 left-2 z-1 cursor-default disabled:opacity-100",
                UNIT_BADGE_PADDING_CLASS,
                UNIT_BADGE_TYPE_CLASS,
                // A long device name wraps instead of running off the plot. Both heights have to go:
                // size xs sets one behind a sm: prefix, which the unprefixed h-auto doesn't replace.
                "h-auto min-h-6 max-w-[calc(100%_-_--spacing(4))] items-start justify-start whitespace-normal text-left sm:h-auto",
            )}
            disabled
            size={"xs"}
            variant={"outline"}
        >
            {/* One flex child: the Button's gap-1 would push the two apart on top of the separator.
                leading-none here, not on the label's spans: the line box comes from this block. */}
            <div className={"leading-none"}>
                <SeriesLabel deviceName={deviceName} unitCategory={unitCategory} />
            </div>
        </Button>
    );
}
